import { Component, inject } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-staking-section',
  standalone: true,
  templateUrl: './staking-section.component.html'
})
export class StakingSectionComponent {
  public state = inject(AppStateService);
}
